import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
// import { getAjaxhelper } from '../utils/CoreAjaxHelper';
// import { getCmsHome3HotButton } from '../utils/index';
// import { CMS } from '../shared/index';
import { newI18n } from '../core/Const';

export interface Homesection1Props extends BaseComponentProps {
    lang: string;
}
export interface Homesection1State extends BaseComponentState { 
}
export class Homesection1 extends BaseComponent<Homesection1Props, Homesection1State> {

    bookWithUs = {
        Title: newI18n("HOME.WHYBOOkWITHUS.Title", "Why Book With Us?"),
        SubTitle: newI18n("HOME.WHYBOOkWITHUS.SubTitle", ""),
        data: [
            {
                "id": 1,
                "translationcode": "HOME.WHYBOOkWITHUS.one.Title",
                "title": "FREE Airport Transfers Included*",
                "icon": "fa fa-bus",
            },
            {
                "id": 2,
                "translationcode": "HOME.WHYBOOkWITHUS.two.Title",
                "title": "Your Own Dedicated Customer Support Staff That Live In Bali",
                "icon": "fa fa-user-plus",
            },
            {
                "id": 3,
                "translationcode": "HOME.WHYBOOkWITHUS.three.Title",
                "title": "Corporate Events, Weddings Parties And Special Events Catered For",
                "icon": "fa fa-star",
            },
            {
                "id": 4,
                "translationcode": "HOME.WHYBOOkWITHUS.four.Title",
                "title": "All Taxes And Service Fees Included - No Hidden Extra Charges",
                "icon": "fa fa-dollar",
            },
            {
                "id": 5,
                "translationcode": "HOME.WHYBOOkWITHUS.five.Title",
                "title": "Interest-Free Payment Options",
                "icon": "fa fa-tags"
            },
            {
                "id": 6,
                "translationcode": "HOME.WHYBOOkWITHUS.six.Title",
                "title": "We Support Local Bali Charities. Your Booking Helps Bali Locals",
                "icon": "fa fa-users"
            }
        ]
    }; 
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let a = [];
        if (this.bookWithUs.data.length > 0) {
            let lop = 0;
            for (let x of this.bookWithUs.data) {
                lop++;
                a.push(
                    <div key={lop} className="col-md-4 col-sm-6">
                        <div className="padding-top-20 padding-bottom-20 no-visible fadeIn animated" >
                            <div className="pull-left no-visible bounceIn animated" data-appears-class="bounceIn" data-appears-delay="80">
                                <i className={`text-primary ${x.icon}`} style={{ fontSize: 40 }} />
                            </div>
                            <div>
                                <div style={{ paddingLeft: 60 }}>
                                    <h4 className=""> {newI18n(x.translationcode, x.title)}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

        }

        return (
            <section className="container-fluid container-fullw bg-white">
                <div className="container">
                    <div className="row">
                        <div >
                            <h3 style={{ textAlign: 'center' }}> {this.bookWithUs.Title} </h3>
                            <hr/>
                            <h4 style={{ textAlign: 'center' }}> {this.bookWithUs.SubTitle} </h4>
                            {a}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
} 


// WEBPACK FOOTER //
// ./src/home/Homesection1.tsx